export type FinanceTab = { id: string; title: string; link: string; exactSuperadminOnly?: boolean };

export const FINANCE_TABS: FinanceTab[] = [
  { id: 'funds-movements', title: 'Funds Movements', link: '/finance/funds-movements' },
  { id: 'settlements', title: 'Settlements', link: '/finance/settlements' },
  { id: 'invoices', title: 'Invoices', link: '/finance/invoices' },
  { id: 'reports', title: 'Reports', link: '/finance/reports' },
  { id: 'tango-ledger', title: 'Tango Ledger', link: '/finance/tango-ledger', exactSuperadminOnly: true },
  { id: 'ledger', title: 'Ledger', link: '/finance/ledger' },
  { id: 'dwolla-reconciliation', title: 'Dwolla Reconciliation', link: '/finance/dwolla-reconciliation' },
  { id: 'bank-reconciliation', title: 'Bank Reconciliation', link: '/finance/bank-reconciliation' },
  { id: 'connections', title: 'Connections', link: '/finance/connections', exactSuperadminOnly: true },
];
